import React, { Component } from "react";
import {
  Dialog, IconButton, Button, Icon,
  Fab, Grid, DialogActions,
  FormControl, MenuItem,
  TextField,
  InputLabel, Grow,
  Select, ListSubheader, withStyles,
  DialogTitle, Tooltip, Chip, makeStyles, Avatar,
} from "@material-ui/core";
import InputAdornment from '@material-ui/core/InputAdornment';
import DateFnsUtils from "@date-io/date-fns";
import { connect } from "react-redux";
import * as actionCreators from "../../store/actions/index"
import { MegadraftEditor, editorStateFromRaw, editorStateToJSON, MegadraftPlugin, insertDataBlock } from "megadraft-denistsuman";
import { convertFromHTML, EditorState, ContentState, Modifier, Entity, genKey, ContentBlock } from 'draft-js';
import LinkInput from "megadraft-denistsuman/lib/entity_inputs/LinkInput";
import icons from "megadraft-denistsuman/lib/icons"
import 'megadraft-denistsuman/dist/css/megadraft.css'
import FontAwesome from "react-fontawesome";
import { stateToHTML } from 'draft-js-export-html';
import clearFormatting from 'draft-js-clear-formatting';
import { split } from "apollo-boost";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactDOM from 'react-dom';
import FormatClearIcon from '@material-ui/icons/FormatClear';

const IconSmall = withStyles(() => ({
  root: {
    fontSize: "1.0rem",
  }
}))(Icon);
const TooltipNew = withStyles((theme) => ({
  tooltip: {
    fontSize: 14,
  },
}))(Tooltip);

const StyledChip = withStyles({
  root: {
    margin: "3px",
    padding: "inherit",
  },
})(Chip);

const IconSmalladd = withStyles(() => ({
  root: {
    fontSize: "1.0rem",
    '&:hover': {
      fontSize: "1.2rem",
      margin: "3px 0px"
    }
  },
}))(Icon);
let messageeditstate = '';

class UnderlineIcon extends React.Component {
  render() {
    return (
      <>
        <div className="pt-12">
          <FontAwesome className={"fa fa-underline toolbar__button"} style={{ fontSize: '18px', paddingBottom: '15px', paddingTop: "0px" }} />
        </div>
      </>
    );
  }
}
class ClearFormattingIcon extends React.Component {
  render() {
    return (
      <>
        <div className="pt-12">
          {/* <FontAwesome className={"fas fa-remove-format toolbar__button"} style={{ fontSize: '18px', paddingBottom: '15px', paddingTop: "0px" }} /> */}
          <FormatClearIcon onClick={this.clearFormating} style={{ paddingBottom: '6px', width : '30px', height : '30px' }}/>
        </div>
      </>
    );
  }
}

const entityInputs = {
  LINK: LinkInput,
}

class InboxComposeMultipleDialog extends Component {
  constructor(props) {
    super(props);
    const myContent = {
      "entityMap": {},
      "blocks": [
        {
          "key": genKey(),
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }
      ]
    };
    const exampleState = {
      "blocks": [{
        "key": genKey(),
        "text": "",
        "type": "unstyled",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
      }],
      "entityMap": {}
    };
    const editorState = editorStateFromRaw(myContent);
    messageeditstate = editorState;
    let subjectEditorState = editorStateFromRaw(exampleState);
    this.state = {
      isshared: false,
      editorState: editorState,
      subject: subjectEditorState,
      toEmail: [],
      ccEmail: [],
      bccEmail: [],
      hasCC: false,
      hasBCC: false,
      messageid: "",
      threadid: "",
      attachment: [],
      usersListArray: [],
      mainEmail: "",
      isSubmitDisable: true,
      fullScreen: false,
      minimizeScreen: false,
      readOnlySubject: false,
      toEmailError: false,
    };
    this.ccEmail = React.createRef();
    this.bccEmail = React.createRef();
    this.toEmail = React.createRef();


  }
  componentWillMount() {
    this.props.getEmailTemplateList(this.props.apolloClient.client);
    this.props.getUserList(this.props.apolloClient.client)
    if (this.props.userSelectedEmail) {
      var to = [];
      to.push(this.props.userSelectedEmail)
      this.setState({ toEmail: this.props.userSelectedEmail, })
    }
    if (this.props.emaildata) {
      var allEmailList = this.props.emaildata.emailTo
      console.log("data allEmailList", allEmailList)
      var toData = [...this.state.toEmail];
      var ccData = [...this.state.ccEmail];
      var bccData = [...this.state.bccEmail];
      allEmailList.map((data) => {
        if (data.email_type === 1) {
          console.log("from ", data.email)
        } else if (data.email_type === 2) {
          toData = [...toData, data.email];
        } else if (data.email_type === 3) {
          ccData = [...ccData, data.email];
        } else {
          bccData = [...bccData, data.email];
        }
      })
      let editorSubjectState = this.state.subject;
      let currentContent = editorSubjectState.getCurrentContent();
      let selection = editorSubjectState.getSelection();
      let entityKey1 = Entity.create('UNSTYLED', 'MUTABLE', "Re:" + this.props.emaildata.subject);
      let textWithEntity1 = Modifier.insertText(currentContent, selection, "Re:" + this.props.emaildata.subject, null, entityKey1);
      editorSubjectState = EditorState.push(editorSubjectState, textWithEntity1, 'insert-characters');
      this.handleChangeSubject(editorSubjectState)
      this.setState({
        toEmail: toData,
        ccEmail: ccData,
        bccEmail: bccData,
        hasCC: ccData.length > 0 ? true : false,
        hasBCC: bccData.length > 0 ? true : false,
        messageid: this.props.emaildata.emaildetails.message_id,
        threadid: this.props.emaildata.emaildetails.thread_id,
        readOnlySubject: true
      })
    }
  }
  componentWillReceiveProps(props) {
    if (props.settingReducer.usersListArray.data && this.state.usersListArray.length == 0) {
      const usersListArray = props.settingReducer.usersListArray.data;
      this.setState({ usersListArray: usersListArray })
    }
  }
  onChange = (editorState) => {
    messageeditstate = editorState;
    this.setState({
      editorState: editorState,
      isSubmitDisable:
        (this.state.toEmail.length > 0 && this.state.attachment.length > 0)
          || (this.state.subject.getCurrentContent().hasText() && editorState.getCurrentContent().hasText()) ?
          false : true
    })
  }

  handleChangeSubject = (subject) => {
    this.setState({
      subject: subject,
      isSubmitDisable: (this.state.toEmail.length > 0 && this.state.attachment.length > 0)
        || (subject.getCurrentContent().hasText() && this.state.editorState.getCurrentContent().hasText()) ?
        false : true
    })
  }

  getCustomSidebar = (props) => {
    // return <CustomSidebar thisData={this} editorType="Message" />
    return <div>{""}</div>
  }
  getCustomSubjectSidebar = (props) => {
    // return <CustomSidebar thisData={this} editorType="Subject" />/
    return <div>{""}</div>
  }
  findWithAttr = (array, attr, value) => {
    for (var i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i;
      }
    }
    return -1;
  };
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }
  handleFormSubmit = () => {
    const { editorState, toEmail, attachment, bccEmail, ccEmail } = this.state;

    let html = stateToHTML(editorState.getCurrentContent());
    const subjectwithhtml = this.state.subject.getCurrentContent();
    const subjectText = subjectwithhtml.getPlainText('\u0001');
    let SendParams = [];
    SendParams['Send'] = {
      mail: {
        to: toEmail.join(),
        cc: ccEmail.join(),
        bcc: bccEmail.join(),
        subject: subjectText,
        message: html,
        threadid: this.state.threadid,
        messageid: this.state.messageid,
      },
      fileInput: attachment
    }
    SendParams['LogDetails'] = {}
    SendParams['LogComponent'] = "FromNullCom"

    console.log("SendParams", SendParams);

    this.props.sendGmail(this.props.apolloClient.client, SendParams);
    this.props.handleClose();
  }
  handleAttachmentSelection = (event) => {
    var allfiles = this.state.attachment;
    for (let i = 0; i < event.target.files.length; i++) {
      allfiles.push(event.target.files[i])
    }
    this.setState({
      attachment: allfiles, isSubmitDisable: allfiles.length > 0 ? false : true
    });
  };
  validateEmailList = (raw) => {
    var valid = true;
    var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    for (var i = 0; i < raw.length; i++) {
      if (raw[i] == " " || !regex.test(raw[i].replace(/\s/g, ""))) {
        valid = false;
      }
    }
    return valid;
  }
  handleChangeTag = (val, fname) => {
    if (this.validateEmailList(val)) {
      console.log("vallida")
      setTimeout(() => {
        this[fname].current.classList.remove("email_error")
      }, 0);
      this.setState({
        [fname]: val,
        isSubmitDisable: !(val.length > 0 && this.state.subject.getCurrentContent().hasText() && this.state.editorState.getCurrentContent().hasText())
      })
    } else {
      console.log("not validateEmailList", this[fname])
      setTimeout(() => {
        this[fname].current.focus();
        this[fname].current.classList.add("email_error")

      }, 0)
      this.setState({ isSubmitDisable: true });
    }
  };
  toggleCC = () => {
    setTimeout(() => {
      this.ccEmail.current.focus();
    }, 0)

    this.setState({ hasCC: !this.state.hasCC })
  }
  toggleBCC = () => {
    setTimeout(() => {
      this.bccEmail.current.focus();
    }, 0)
    this.setState({ hasBCC: !this.state.hasBCC })
  }

  deleteFile = (id) => {
    var array = [...this.state.attachment]; // make a separate copy of the array
    if (id !== -1) {
      array.splice(id, 1);
      this.setState({ attachment: array, isSubmitDisable: array.length > 0 ? false : true });
    }
  }
  handleMinimize = () => {
    this.setState({ minimizeScreen: !this.state.minimizeScreen, fullScreen: false });
  };
  handleFull = () => {
    this.setState({ fullScreen: !this.state.fullScreen, minimizeScreen: false });
  };
  handleDelete = (item, name) => {
    this.setState({
      [name]: this.state[name].filter(i => i !== item)
    });
  };
  handlePaste = (evt, name) => {
    evt.preventDefault();
    var paste = evt.clipboardData.getData("text");
    console.log("{() => ", paste, name)
    var emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);
    if (emails) {
      this.setState({ [name]: [...this.state[name], ...emails] });
    }
  };
  handleChangeText = (e, fname) => {
    var that = this;
    if (e.target.value === "") {
      setTimeout(() => {
        that[fname].current.classList.remove("email_error")
      }, 0);
      that.setState({
        isSubmitDisable: that.state.subject.getCurrentContent().hasText() && that.state.editorState.getCurrentContent().hasText()
      })
    }
  }
  render() {
    let { open, handleClose, } = this.props;
    let { attachment, bccEmail, toEmail, ccEmail, minimizeScreen, fullScreen } = this.state;
    let onChangeFunction = this.onChange;
    return (
      <Dialog onClose={handleClose} open={open} maxWidth="md" fullWidth={true} className={`custom_dialog ${minimizeScreen && fullScreen ? 'alignitemsend-fullscreen' : ''} ${minimizeScreen ? 'alignitemsend' : ''} ${fullScreen ? 'fullscreen' : ''}`} disableBackdropClick >
        <div className="crm-custom-bg-primary">
          <div className="d-flex justify-content-between align-items-center pl-16 pr-4 py-4 bg-primary ">
            <h4 className="m-0 text-white">Send Email</h4>
            <div className="d-flex">
              <TooltipNew title={minimizeScreen ? 'Normal Screen' : 'Minimize Screen'}>
                <IconButton onClick={this.handleMinimize}>
                  <Icon className="text-white">{minimizeScreen ? 'add' : 'remove'}</Icon>
                </IconButton>
              </TooltipNew>
              <TooltipNew title={fullScreen ? 'Exit Full Screen' : 'Full Screen'}>
                <IconButton onClick={this.handleFull}>
                  <Icon className="text-white">{fullScreen ? 'fullscreen_exit' : 'fullscreen'}</Icon>
                </IconButton>
              </TooltipNew>
              <TooltipNew title="Close">
                <IconButton onClick={handleClose}>
                  <Icon className="text-white">clear</Icon>
                </IconButton>
              </TooltipNew>
            </div>
          </div>
          <div className="crm_dialog_create_template">
            <div className={`${this.state.isDataLoading ? "dialog-body popupHeightCustom" : "dialog-body"}`}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Autocomplete
                    filterSelectedOptions
                    disableClearable
                    multiple
                    freeSolo
                    value={toEmail}
                    name={"toEmail"}
                    id="tagInputId"
                    options={this.state.usersListArray && this.state.usersListArray.map(option => option.email && option.email)}
                    onChange={(event, value) => this.handleChangeTag(value, "toEmail")}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <StyledChip variant="default"
                          key={index}
                          size="small"
                          label={option}
                          onDelete={() => (this.handleDelete(option, "toEmail"))}
                        />
                      ))
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        autoFocus
                        ref={this.toEmail}
                        className="w-100 input_bx"
                        onChange={(e) => this.handleChangeText(e, "toEmail")}
                        onKeyDown={(e) => {
                          if (e.keyCode === 32 && e.target.value) {
                            this.handleChangeTag(toEmail.concat(e.target.value), "toEmail");
                          }
                          if (e.key === 'Backspace') {
                            e.stopPropagation();
                          }
                        }}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (<React.Fragment>
                            <label className="compose_fieldName">TO</label>
                            {params.InputProps.startAdornment}</React.Fragment>
                          ),
                          endAdornment: (
                            <React.Fragment>
                              <label className="compose_ext_name"
                                style={{ display: this.state.hasCC ? "none" : "block" }}
                                onClick={() => this.toggleCC()}>CC</label>
                              <label className="compose_ext_name"
                                onClick={() => this.toggleBCC()}
                                style={{ display: this.state.hasBCC ? "none" : "block" }}
                              >BCC</label>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}

                      />
                    )}
                  />

                </Grid>
                {this.state.hasCC &&
                  <Grid item xs={12}>
                    <Autocomplete
                      filterSelectedOptions
                      disableClearable
                      multiple
                      freeSolo
                      value={ccEmail}
                      name={"ccEmail"}
                      id="tagInputId2"
                      options={this.state.usersListArray && this.state.usersListArray.map(option => option.email && option.email)}
                      onChange={(event, value) => this.handleChangeTag(value, "ccEmail")}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <StyledChip variant="default"
                            key={index}
                            size="small"
                            label={option}

                            onDelete={() => this.handleDelete(option, "ccEmail")}
                          />
                        ))
                      }
                      renderInput={params => (
                        <TextField
                          {...params}
                          autoFocus
                          className="w-100 input_bx"
                          ref={this.ccEmail}
                          onChange={(e) => this.handleChangeText(e, "ccEmail")}
                          onKeyDown={(e) => {
                            if (e.keyCode === 32 && e.target.value) {
                              this.handleChangeTag(ccEmail.concat(e.target.value), "ccEmail");
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <React.Fragment>
                                <label className="compose_fieldName">CC</label>
                                {params.InputProps.startAdornment}
                              </React.Fragment>
                            )
                          }}
                        />
                      )
                      }
                    />
                  </Grid>
                }
                {this.state.hasBCC &&
                  <Grid item xs={12}>
                    <Autocomplete
                      filterSelectedOptions
                      disableClearable
                      multiple
                      value={bccEmail}
                      name={"bccEmail"}
                      id="tagInputId3"
                      options={this.state.usersListArray.map(option => option.email)}
                      freeSolo
                      onChange={(event, value) => this.handleChangeTag(value, "bccEmail")}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <StyledChip variant="default"
                            key={index}
                            size="small"
                            label={option}
                            onDelete={() => this.handleDelete(option, "bccEmail")}
                          />
                        ))
                      }
                      renderInput={params => (
                        <TextField
                          {...params}
                          autoFocus
                          ref={this.bccEmail}
                          className="w-100 input_bx"
                          onChange={(e) => this.handleChangeText(e, "bccEmail")}
                          onKeyDown={(e) => {
                            if (e.keyCode === 32 && e.target.value) {
                              this.handleChangeTag(bccEmail.concat(e.target.value), "bccEmail");
                            }
                          }}

                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <React.Fragment>
                                <label className="compose_fieldName">BCC</label>
                                {params.InputProps.startAdornment}
                              </React.Fragment>
                            )
                          }}
                        />
                      )}
                    />
                  </Grid>
                }
                <Grid item xs={12} className="subject-editor">
                  <MegadraftEditor
                    placeholder='Subject'
                    theme="white-thin"
                    editorState={this.state.subject}
                    onChange={this.handleChangeSubject}
                    actions={[]}
                    readOnly={this.state.readOnlySubject}
                    sidebarRendererFn={this.getCustomSubjectSidebar}
                  />
                </Grid>
                <Grid item xs={12} className="message-editor Scroll_upload">
                  <MegadraftEditor
                    placeholder='Message'
                    theme="white-thin"
                    editorState={this.state.editorState}
                    onChange={this.onChange}
                    actions={[
                      { type: "inline", label: "B", style: "BOLD", icon: icons.BoldIcon },
                      { type: "inline", label: "I", style: "ITALIC", icon: icons.ItalicIcon },
                      { type: "inline", label: "U", style: "UNDERLINE", icon: UnderlineIcon },
                      {
                        type: "custom", icon: ClearFormattingIcon, action() {
                          let options = {
                            inline: true,
                            entities: false,
                            lists: false,
                          }
                          const newEditorState = clearFormatting(messageeditstate, options)
                          messageeditstate = newEditorState;
                          onChangeFunction(newEditorState);
                        }, active() { }
                      },
                      { type: "separator" },
                      { type: "block", label: "UL", style: "unordered-list-item", icon: icons.ULIcon },
                      { type: "block", label: "OL", style: "ordered-list-item", icon: icons.OLIcon },
                      { type: "separator" },
                      { type: "entity", label: "Link", style: "link", entity: "LINK", icon: icons.LinkIcon },
                    ]}
                    entityInputs={entityInputs}
                    sidebarRendererFn={this.getCustomSidebar}
                  />
                  {attachment.map((att, i) => {
                    return <StyledChip
                      key={i}
                      label={att.name}
                      size="small"
                      onDelete={(e) => { this.deleteFile(e, att) }}
                    />
                  })}
                </Grid>
              </Grid>
              <DialogActions className="dialog-action">
                <Grid container spacing={2} justify="space-between" alignItems="center">
                  <Grid item>
                    <label htmlFor="attachment">
                      <Fab color="primary" size="small" onClick={() => this.attachment.click()} className="fab_primary" aria-label="attachment">
                        <Icon>attach_file</Icon>
                      </Fab>
                    </label>
                    <input style={{ display: 'none' }} type="file" multiple
                      onChange={this.handleAttachmentSelection}
                      ref={attachment => this.attachment = attachment} />
                  </Grid>
                  <Grid item>
                    <Button variant="contained" className="mr-12" onClick={handleClose}>Cancel</Button>
                    {
                      this.state.isSubmitDisable ?
                        <Button variant="contained" disabled color="default" >Send</Button>
                        :
                        <Button variant="contained" type="submit"
                          color={"primary"} className="btn_Primary" onClick={this.handleFormSubmit}>Send</Button>
                    }
                  </Grid>
                </Grid>
              </DialogActions>
            </div>

          </div>
        </div>
      </Dialog >
    );
  }
}
const mapStateToProps = (state) => ({
  settingReducer: state.settingReducer,
  apolloClient: state.apolloClient,
  leadReducer: state.leadReducer,
  contactReducer: state.contactReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {
    getEmailTemplateList: (client, request) => { dispatch(actionCreators.getEmailTemplateList(client, request)) },
    sendGmail: (client, req) => dispatch(actionCreators.sendGmail(client, req)),
    getUserList: (client) => dispatch(actionCreators.getUserList(client)),
    saveEmailTemplate: (client, request) => { dispatch(actionCreators.saveEmailTemplate(client, request)); },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(InboxComposeMultipleDialog);